import moment from "moment";
import { utils, writeFileXLSX } from "xlsx";

import { formatBRL } from "../../monitoramento-preco/components/mpUtils";
import { TIPO_COLETA } from "./mapColetaTableRow";

function formatEnvioUtc(value) {
  if (!value) return "";
  return moment.utc(value).local().format("DD/MM/YYYY HH:mm");
}

function formatConcorrenteResumo(concorrentes) {
  if (!Array.isArray(concorrentes) || concorrentes.length === 0) return "";

  return concorrentes
    .map((c) => {
      const nome = c.nomeProduto ? `${c.nome} — ${c.nomeProduto}` : c.nome;
      if (!c.encontrado) return `${nome}: não encontrado`;
      let texto = `${nome}: normal ${formatBRL(c.precoNormal)}`;
      if (c.emPromocao && c.precoPromocional != null) {
        texto += `; promo ${formatBRL(c.precoPromocional)}`;
      }
      if (c.temFoto) texto += " (foto)";
      return texto;
    })
    .join(" | ");
}

function buildColetasRows(items) {
  return (items || []).map((coleta) => ({
    "ID coleta": coleta.idColeta ?? "",
    "Data envio": formatEnvioUtc(coleta.dataEnvioUtc),
    "Data coleta": coleta.dataColeta ?? "",
    Representante: coleta.representante ?? "",
    "Razão social": coleta.loja?.razaoSocial ?? "",
    "Grupo econômico": coleta.loja?.grupoEconomico ?? "",
    Cidade: coleta.loja?.cidade ?? "",
    UF: coleta.loja?.uf ?? "",
    Marca: coleta.produto?.marca ?? "",
    SKU: coleta.produto?.sku ?? "",
    Produto: coleta.produto?.nome ?? "",
    Linha: coleta.produto?.linha ?? "",
    Categoria: coleta.produto?.categoria ?? "",
    "Preço na loja": coleta.precoMarcaLoja ?? coleta.precoKarstenLoja ?? "",
    "Tipo coleta": TIPO_COLETA[coleta.tipoColeta] ?? "",
    Concorrentes: formatConcorrenteResumo(coleta.concorrentes),
  }));
}

function buildConcorrentesRows(items) {
  const rows = [];

  (items || []).forEach((coleta) => {
    const base = {
      "ID coleta": coleta.idColeta ?? "",
      "Data coleta": coleta.dataColeta ?? "",
      SKU: coleta.produto?.sku ?? "",
      Produto: coleta.produto?.nome ?? "",
      Loja: coleta.loja?.razaoSocial ?? "",
    };

    const concorrentes = coleta.concorrentes ?? [];
    if (!concorrentes.length) {
      rows.push({
        ...base,
        Marca: "",
        "Produto concorrente": "",
        Encontrado: "",
        "Preço normal": "",
        "Em promoção": "",
        "Preço promocional": "",
        "Tem foto": "",
      });
      return;
    }

    concorrentes.forEach((c) => {
      rows.push({
        ...base,
        Marca: c.nome ?? "",
        "Produto concorrente": c.nomeProduto ?? "",
        Encontrado: c.encontrado ? "Sim" : "Não",
        "Preço normal": c.encontrado ? (c.precoNormal ?? "") : "",
        "Em promoção": c.emPromocao ? "Sim" : "Não",
        "Preço promocional":
          c.emPromocao && c.precoPromocional != null ? c.precoPromocional : "",
        "Tem foto": c.temFoto ? "Sim" : "Não",
      });
    });
  });

  return rows;
}

export default function exportColetasXlsx(items, { truncated = false } = {}) {
  const wb = utils.book_new();
  const coletasSheet = utils.json_to_sheet(buildColetasRows(items));
  const concorrentesSheet = utils.json_to_sheet(buildConcorrentesRows(items));

  utils.book_append_sheet(wb, coletasSheet, "Coletas");
  utils.book_append_sheet(wb, concorrentesSheet, "Concorrentes");

  const suffix = moment().format("YYYY-MM-DD_HHmm");
  const truncatedLabel = truncated ? "_parcial" : "";
  writeFileXLSX(
    wb,
    `HistoricoColetasPreco${truncatedLabel}_${suffix}.xlsx`,
  );
}
